// extracted by mini-css-extract-plugin
export var brand = "_1d-8";
export var compact = "_1d-5";
export var extraSmall = "_1d-6";
export var icon = "_1d-0";
export var large = "_1d-3";
export var light = "_1d-1";
export var medium = "_1d-4";
export var outline = "_1d-a";
export var primaryDark = "_1d-9";
export var primaryLight = "_1d-7";
export var primaryModern = "_1d-b";
export var success = "_1d-2";